// Electron packaged app injects its configured HTTPS backend via preload
// (window.desktop.apiUrl). Web build / dev keep the value below unchanged.
const DESKTOP_API = typeof window !== 'undefined' && window.desktop && window.desktop.apiUrl;

// export const REST_API = DESKTOP_API || 'http://localhost:4000';
// export const REST_API_ENDPOINT = `${REST_API}/webservices`;

export const VERSION = '1.57';

// AI Analytics (trading) is served through the Node backend at /api/sefi/*
// (see _apis_/aiAnalytics.js). The frontend no longer calls FastAPI :8000 directly.

export const REST_API = 'https://new-al-ikhtayar.skyniche.website/backend';
export const REST_API_ENDPOINT = 'https://new-al-ikhtayar.skyniche.website/backend/webservices';